import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=8ffdf3a4"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ffdf3a4')) {
      api.createRecord('8ffdf3a4', component.options)
    } else {
      api.reload('8ffdf3a4', component.options)
    }
    module.hot.accept("./Image.vue?vue&type=template&id=8ffdf3a4", function () {
      api.rerender('8ffdf3a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Image.vue"
export default component.exports